export default __webpack_public_path__ + "static/media/iconn4.6d0efd0b.svg";